import Styles from './CMSRolesDropDown.module.scss';
import { useEffect, useState } from 'react';
import Multiselect from '../../../../../../components/UI/Input/Multiselect/Multiselect';
import { GetAllRoles } from '../../../CMS_api';

const CMSRolesDropDown = ({ name, disabled, onChange, field, id }) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		//populate dropdown with role options
		GetAllRoles().then(result => {
			let options = [];
			try {
				options = result.data.map(role => {
					return {
						value: role.Search.toString(),
						isSelected: determineIsSelected(role.ID),
						DataID: role.ID,
					};
				});
			} catch (ex) {
				console.error(ex);
			}
			//Add 'All' Option as first option
			options.unshift({
				value: 'All Users',
				isSelected: determineIsSelected('All Users'),
				DataID: 'All Users',
			});
			setOptions(options);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//param optionsIndex: int - index position in options array. passed by MultiSelect internal onChange handler
	const handleSelect = optionsIndex => {
		//if disabled != true, handleRemove, else do nothing
		if (!disabled) {
			//call onChange prop. in this context, the onChange callback expects an event argument,
			// mock event object schema to avoid having to implement an additional onChange handler in CMSObjectForm.js
			let localValue = field.PendingUpdateApprovalValue;
			//if PendingUpdateApproval is undefined, assign Value instead
			if (localValue === undefined || localValue === null) {
				localValue = field.Value;
			}

			//determine if the selected option is already selected, if so, treat it as being removed (unchecked)
			let isSelected = determineIsSelected(options[optionsIndex].DataID);

			let prevValue = [];
			let newValue = [];
			if (!isSelected) {
				//add
				prevValue = localValue.split(',');
				prevValue.push(options[optionsIndex].DataID);
				newValue = prevValue;
			} else {
				//remove
				prevValue = localValue.split(',');
				let index = prevValue.indexOf(
					options[optionsIndex].DataID.toString()
				);
				if (index > -1) {
					prevValue.splice(index, 1);
				}
				newValue = prevValue;
			}

			//mock event object
			let event = {
				target: {
					name: name,
					value: newValue.join(','),
				},
			};
			//call onChange prop and pass mock event to update object
			onChange(event);
		}
	};

	//function handleRemove(option)
	//param (option) - object {
	//     value: String,
	//     isSelected: Boolean,
	//     isDisplayed: Boolean
	// }
	//passed by multiSelect component in this context
	const handleRemove = option => {
		//if disabled != true, handleRemove, else do nothing
		if (!disabled) {
			//get the data ID of the option from options state array

			let dataID = options.find(opt => opt.value === option.value).DataID;
			let localValue = field.PendingUpdateApprovalValue;
			if (localValue === undefined || localValue === null) {
				localValue = field.Value;
			}
			let prevValue = [];
			let newValue = [];
			prevValue = localValue.split(',');
			let index = prevValue.indexOf(dataID.toString());
			//remove the id at the specified index
			if (index > -1) {
				prevValue.splice(index, 1);
			}
			newValue = prevValue;

			//mock event object
			let event = {
				target: {
					name: name,
					value: newValue.join(','),
				},
			};
			//call onChange prop and pass mock event to update object
			onChange(event);
		}
	};

	const determineIsSelected = roleID => {
		let localValue = field?.PendingUpdateApprovalValue;
		//if PendingUpdateApproval is undefined, assign Value instead
		if (localValue === undefined || localValue === null) {
			localValue = field?.Value;
		}

		let selectedArr = [];
		if (localValue != null) {
			selectedArr = localValue.split(',');
		}

		if (roleID !== undefined && roleID !== null) {
			return selectedArr.includes(roleID.toString());
		} else {
			return false;
		}
	};

	//re-implement when addressing search issues TODO
	// const searchHandler = (searchTerm)=>{
	//     //not currently used, requires troubleshooting of multiselect component
	//     let valueArray = options.map(opt=> opt.value)
	//     const filter = (option) =>{
	//         return (

	//             option.toLowerCase().includes(searchTerm.toLowerCase())
	//         )
	//     }

	//     return valueArray.filter(opt=>filter(opt))
	// }

	const MultiSelectSettings = {
		type: 'LIST',
		selectHandler: handleSelect,
		chipHandler: handleRemove,
		isDisabled: disabled,
		//search functionality not currently functional, searching removes all selected items from the selected items display. TODO
		// isSearchable: true,
		// searchHandler: searchHandler
	};

	return (
		<div id='CMSRoleMultiSelect_Container' className={Styles.container}>
			<Multiselect
				options={options}
				settings={MultiSelectSettings}
				id={id}
			/>
		</div>
	);
};

export default CMSRolesDropDown;
